module.exports = __webpack_public_path__ + "assets/images/XCD20.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/XCD20.png
// module id = 1477
// module chunks = 1